import PersonaExample from "./examples/Persona.Example";
import personaMaleImage from "./examples/persona-male.png";

export default [
    {
        title: "Basic persona",
        code: require("!raw-loader!./examples/Persona.Example.tsx"),
        component: PersonaExample,
        dependencies: {
            "Persona.Example.css": require("!raw-loader!./examples/Persona.Example.css"),
            "persona-male.png": personaMaleImage
        }
    }
];
